let outboundlist = [
  { title: "Packing and Loading", label: "cppack" },
  { title: "Transportation", label: "cpouttrans" },
  { title: "Export Clearance", label: "cpexport" },
  { title: "Shipping", label: "cpship" },
  { title: "Destination", label: "cpdest" },
];
export default outboundlist;
